const LoadingSpinner = ({ message = "جارٍ التحميل..." }) => (
  <div className="text-center py-4" role="status" aria-live="polite">
    <div className="spinner-border text-warning" />
    <p className="mt-2">{message}</p>
  </div>
);

export default LoadingSpinner;
